import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { ModuleDialogs } from '../../constants/Dialogs';
import PropTypes from 'prop-types';
import { statusColours } from '../../constants/ColourConstants';
import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate, FormattedTime } from 'react-intl';

import Checkbox from 'material-ui/Checkbox';
import DatePicker from 'material-ui/DatePicker';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import StatusIcon from 'material-ui/svg-icons/action/done';
import CancelledIcon from 'material-ui/svg-icons/content/clear';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import SelectUser from '../User/SelectUser';

class ModuleEnrolmentDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
    }

    render() {
        if (this.state.open !== ModuleDialogs.ENROLMENT_ADD && this.state.open !== ModuleDialogs.ENROLMENT_EDIT) { return null; } // guard: dialog not open

        const date = new Date();
        date.setMonth(date.getMonth() - 2);

        return (
            <Dialog
                title={this.props.title}
                open={true}
                modal={false}
                onRequestClose={this.props.onClose}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel}/>,
                    <FlatButton key="submit" label={this.state.open === ModuleDialogs.ENROLMENT_ADD ? 'Save' : 'Update'} onTouchTap={this.onSave} disabled={!this.state.draft.userId || !this.state.draft.status}/>
                ]}
            >
                {(this.state.open === ModuleDialogs.ENROLMENT_ADD) && (
                    <SelectUser
                        label="User *"
                        clearOnSelect={false}
                        onSelect={(name, id) => DialogActions.updateDraft('userId', id)}
                        onNewRequest={() => DialogActions.updateDraft('userId', null)}
                    />
                )}
                <SelectField 
                    value={this.state.draft.status}
                    fullWidth={true} 
                    floatingLabelText="Status *"
                    onChange={this.onStatusSelect.bind(this)}
                >
                    {(!!this.state.draft.statuses && this.state.draft.statuses.length > 0) && this.state.draft.statuses.map( (status) => {
                        const icon = status.id !== 'cancelled' ? <StatusIcon color={statusColours[status.id]}/> : <CancelledIcon color={statusColours[status.id]}/>;
                        return (<MenuItem key={status.id} value={status.id} primaryText={status.name} leftIcon={icon}/>);
                    })}
                </SelectField>
                <DatePicker
                    name="dateCompleted"
                    maxDate={new Date()}
                    hintText="Date completed"
                    floatingLabelText="Date completed"
                    value={this.state.draft.dateCompleted}
                    onChange={(e, value) => DialogActions.updateDraft('dateCompleted', value)}
                    disabled={this.state.draft.status !== 'completed'}
                    fullWidth
                />
                <Checkbox
                    defaultChecked={this.state.draft.isMandatory}
                    label="Mandatory"
                    onCheck={({target}, value) => DialogActions.updateDraft('isMandatory', value)}
                />
                { !!this.props.events && (
                    <div>
                        <SelectField
                            name="eventId"
                            floatingLabelText="Event"
                            value={this.state.draft.eventId}
                            onChange={(event, index, value) => DialogActions.updateDraft('eventId', value)}
                            fullWidth
                        >
                            { this.props.events
                                .filter(({id, timeStart}) => id === this.state.draft.currentEvent || timeStart > date)
                                .map(({id, timeStart, venue}) => {
                                    const start = new Date(timeStart);
                                    const text = (
                                        <span>
                                            <FormattedDate {...DateStyles.shortWeekday} value={start} /> at <FormattedTime value={start} />
                                            {!!venue && ` - ${venue}`}
                                        </span>
                                    );
                                    return (<MenuItem key={id} value={id} primaryText={text} />);
                                })
                            }
                        </SelectField>
                        <SelectField
                            name="attendanceStatus"
                            floatingLabelText="Attendance status"
                            value={this.state.draft.attendanceStatus}
                            onChange={(event, index, value) => DialogActions.updateDraft('attendanceStatus', value)}
                            disabled={!this.state.draft.eventId}
                            fullWidth
                        >
                            <MenuItem value="waiting" primaryText="Waiting"/>
                            <MenuItem value="attending" primaryText="Attending"/>
                            <MenuItem value="attended" primaryText="Attended"/>
                            <MenuItem value="did_not_attend" primaryText="Did not attend"/>
                        </SelectField>
                    </div>
                )}
            </Dialog>
        );
    }

    onStatusSelect(event, index, value) {
        if (value !== this.state.draft.status) {
            DialogActions.updateDraft('status', value);
            DialogActions.updateDraft('dateCompleted', value === 'completed' ? new Date() : null);
        }
    }

    onSave() {
        const params = !this.state.draft.dateCompleted
            ? this.state.draft
            : {...this.state.draft, dateCompleted: this.state.draft.dateCompleted.toLocaleString('en-GB', DateStyles.long)};

        const saved = this.props.onSave(params);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

ModuleEnrolmentDialog.getStores = () => ([DialogStore]);
ModuleEnrolmentDialog.calculateState = () => {
    const {open, draft} = DialogStore.getState();
    return {
        open,
        draft,
    };
};

ModuleEnrolmentDialog.propTypes = {
    title:      PropTypes.string.isRequired,
    moduleId:   PropTypes.number.isRequired,
    data:       PropTypes.shape({
        userId:         PropTypes.number,
        status:         PropTypes.string,
        isAssigned:     PropTypes.bool,
        isMandatory:    PropTypes.bool,
        dateCompleted:  PropTypes.object
    }),
    statusList: PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.string.isRequired,
            name:   PropTypes.string.isRequired
        })
    ),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool,
    events:         PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number,
            name:   PropTypes.string
        })
    ),
};

ModuleEnrolmentDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true,
};

export default Container.create(ModuleEnrolmentDialog);
